module.exports = __webpack_public_path__ + "img/logo.48ddb6b7.svg";